import { Component } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { FooterComponent } from '../../shared/footer/footer.component';

@Component({
  selector: 'app-referidos',
  imports: [HeaderComponent, FooterComponent],  
  templateUrl: './referidos.component.html',
  styleUrl: './referidos.component.scss'
})
export class ReferidosComponent {
  footerColorClass = 'footer-promotor';
}
